import config from 'config';
import { useCallback, useRef } from 'react';

type CallbackType<ParamTypes> = (params: ParamTypes) => any;

export const useDebounce = (delay: number = config.UI.DEBOUNCE_DELAY) => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const clearDebounce = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, []);

  const debounce = useCallback(
    <ParamTypes>(callback: CallbackType<ParamTypes>) => {
      return (params: ParamTypes) => {
        clearDebounce();
        timeoutRef.current = setTimeout(() => {
          callback(params);
        }, delay);
      };
    },
    [delay, clearDebounce]
  );

  return { debounce, clearDebounce };
};
